import api from "./api.js";

export default class BannerApi {
  // ---------- 지식상점 홈 배너 ---------- //
  static async create(data) {
    return await api.post(`api/banner`, data);
  }

  static async getList(params) {
    return await api.get(`api/banner`, params);
  }

  static async delete(params) {
    return await api.del(`api/banner`, params);
  }

  static async getById(id) {
    return await api.get(`api/banner/${id}`);
  }

  static async update(id, data) {
    return await api.patch(`api/banner/${id}`, data);
  }
}
